import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'En menos de 5 minutos recibís un mail con el link de descarga. Si no lo recibís, revisá tu carpeta de SPAM antes de contactarnos.'
}, {
  q: '¿Funciona en el interior del país?',
  a: 'Sí. En el interior la competencia es menor y el mercado de iglesias es gigante. El sistema incluye proveedores online para todo el país.'
}, {
  q: '¿Necesito experiencia previa para empezar?',
  a: 'No. El Tomo 1 está diseñado para que arranques desde cero, sin experiencia previa, y consigas tus primeros 5 clientes en la primera semana.'
}, {
  q: '¿Cuánto necesito invertir para empezar a fabricar?',
  a: 'Con $20.000 a $30.000 ARS de inversión inicial podés producir tus primeros 20 frasquitos. El Tomo 5 te enseña a calcular costos para que recuperes la inversión rápido.'
}, {
  q: '¿La garantía es real?',
  a: 'Totalmente real. Escribís a soporte@impulsodigitalstore.com y te devolvemos el 100% sin preguntas dentro de los 7 días.'
}, {
  q: '¿Es un emprendimiento solo para mujeres cristianas?',
  a: 'El sistema está diseñado pensando en mujeres de fe, pero los métodos de fabricación, ventas y escalado funcionan para cualquier persona que quiera emprender con frasquitos.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-brand-base border-t border-white/5 pt-[8px] pb-[8px] relative overflow-hidden" data-id="element-89">
      <div className="absolute top-10 left-1/2 -translate-x-1/2 w-[400px] h-[150px] bg-brand-purple/15 blur-3xl rounded-full pointer-events-none" data-id="element-90"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-91">
        <div className="mb-12" data-id="element-92">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-white flex items-center justify-center gap-3" data-id="element-93">
            <span className="text-brand-lime" data-id="element-94">❓</span> LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-95">
          {faqs.map((faq, i) => <div key={i} className="bg-white/5 backdrop-blur-sm rounded-xl overflow-hidden border-l-4 border-brand-lime border-r border-t border-b border-white/10" data-id="element-96">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-97">
                <span className="font-bold text-lg text-white pr-4" data-id="element-98">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="shrink-0 text-brand-lime" data-id="element-99">
                  <ChevronDown size={24} data-id="element-100" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-101">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-102">
                    <div className="px-6 pb-6 text-gray-300 leading-relaxed text-left" data-id="element-103">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}